export default "__VITE_ASSET__aXUtc5iS__"